import { MicrosoftClarity } from '@lcms/react-analytics';
import { microsoftClarityConfiguration } from 'src/vendors/microsoft-clarity';

export function MicrosoftClarityPlugin() {
    if (microsoftClarityConfiguration.id)
        return <MicrosoftClarity clarityId={microsoftClarityConfiguration.id} />;
    return null;
}
